'use client';

import React from 'react';
import { ExperienceType } from '../types';
import Airports, { Airport } from '@/components/packages/Airports';

interface ExperienceAirportsProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceAirports: React.FC<ExperienceAirportsProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'package') return null;

  const exp = experience as {
    airports?: Airport[];
  };

  if (!Array.isArray(exp?.airports) || exp.airports.length === 0) return null;

  return <Airports airports={exp.airports} />;
};
